const UNASSIGNED_PANEL_PART = 'UNASSIGNED_PANEL_PART'

const isUnassignedLocation = (location = '') =>
  location.includes(UNASSIGNED_PANEL_PART)

export const addRemovedFlag = (obj) => ({
  ...obj,
  isSwitchRemoved: true,
  isSwapReplacement: undefined,
  location: isUnassignedLocation(obj.location) ? '' : obj.location,
})

export const removeTempLocation = (obj) => ({
  ...obj,
  location: '',
})

const stripLocalFlags = ({ isSwapReplacement, ...rest }) => rest

export const createSaveComponentsList = (components, removed, unassigned) => {
  const activeComponents = components
    .filter((c) => !c.isSwitchRemoved)
    .map(stripLocalFlags)
  const activeUnassigned = unassigned.filter((c) => !c.isSwitchRemoved)

  // Exclude removed components that were replaced by a new switch at the same location
  // The API detects replacements implicitly — sending both causes duplicate location entries
  const replacedLocations = new Set(
    activeComponents
      .filter((c) => c.hasBeenAdded)
      .map((c) => c.location)
      .filter(Boolean)
  )
  const trulyRemoved = removed.filter((c) => !replacedLocations.has(c.location))
  const removedWithFlag = trulyRemoved.map(addRemovedFlag)

  const unassignedCleaned = activeUnassigned.map(removeTempLocation)
  return activeComponents.concat(removedWithFlag).concat(unassignedCleaned)
}

export const buildReplacedSwitchesList = (components, removed) =>
  components
    .filter((c) => c.isSwapReplacement && c.hasBeenAdded)
    .map((newSwitch) => {
      const oldSwitch = removed.find(
        (r) => r.location === newSwitch.location && r.isSwapReplacement
      )
      return oldSwitch
        ? {
            oldPanelNumber: oldSwitch.panelNumber,
            newPanelNumber: newSwitch.panelNumber,
          }
        : null
    })
    .filter(Boolean)
